import apiFetch from '../../apiFetch'

export default function (idVerraco, token) {
  return apiFetch({endPoint: `FichaVerraco/getHistoricoIntervenciones?idVerraco=` + idVerraco, method: 'GET', body: null, token: token})
}
